<template>
	<CForm class="main-wrapper form-standard">
		<CRow>
			<CCol lg="12">
				<CInput
					v-model="$v.form.email.$model"
					:label="`${$t('message.email_address')}*`"
					:is-valid="formState.email.valid"
					:invalid-feedback="formState.email.error"
					autocomplete="new-email"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<CInput
					v-model="$v.form.password.$model"
					:label="`${$t('message.password')}*`"
					:is-valid="formState.password.valid"
					:invalid-feedback="formState.password.error"
					type="password"
					autocomplete="new-password"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="6">
				<CInput
					v-model="$v.form.firstName.$model"
					:label="`${$t('message.first_name')}*`"
					:is-valid="formState.firstName.valid"
					:invalid-feedback="formState.firstName.error"
				/>
			</CCol>
			<CCol lg="6">
				<CInput
					v-model="form.lastName"
					:label="$t('message.last_name')"
					:description="$t('message.optional')"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<BaseDropDown
					v-model="form.role"
					:options="roleOptions"
					:label-drop-down="$t('message.user_role')"
					:placeholder="$t('message.selection')"
					:searchable="false"
					label="name"
					track-by="value"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12" class="mt-4 mb-4">
				<BaseSwitch
					v-model="form.status"
					:label="$t('message.status')"
					:checked-text="$t('message.active')"
					:unchecked-text="$t('message.inactive')"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<CInput
					v-model="form.phoneNumber"
					:label="$t('message.phone_number')"
					:description="$t('message.optional')"
				/>
			</CCol>
		</CRow>
		<BaseActionSubmit
			:is-loading="isLoading"
			:submit-text="$t('button.create')"
			:cancel-text="$t('button.cancel')"
			@onSubmit="handleSubmit"
			@onCancel="handleCancel"
		/>
	</CForm>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import { inputStateValid, inputStateError, formatPassword } from '../helpers/vuelidator';
import { USER_ROLE } from '../enums/user';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'UserCreate',

	data() {
		return {
			form: {
				email: null,
				password: null,
				firstName: null,
				lastName: null,
				status: true,
				phoneNumber: null,
				role: {
					name: 'Admin',
					value: USER_ROLE.ADMIN,
				},
			},
			roleOptions: [
				{
					name: 'Admin',
					value: USER_ROLE.ADMIN,
				},
				{
					name: 'User',
					value: USER_ROLE.USER,
				},
			],
		};
	},

	validations: {
		form: {
			email: {
				required,
				email,
			},
			password: {
				required,
				formatPassword,
			},
			firstName: {
				required,
			},
		},
	},

	computed: {
		...mapState('userCreate', {
			error: 'error',
			isLoading: 'isLoading',
		}),
		formState() {
			return {
				email: {
					valid: inputStateValid(this.$v.form.email),
					error: inputStateError(this.$v.form.email)(this),
				},
				password: {
					valid: inputStateValid(this.$v.form.password),
					error: inputStateError(this.$v.form.password)(this),
				},
				firstName: {
					valid: inputStateValid(this.$v.form.firstName),
					error: inputStateError(this.$v.form.firstName)(this),
				},
			};
		},
	},

	methods: {
		...mapActions('toast', {
			showToast: 'showToast',
		}),
		...mapActions('userCreate', {
			createUser: 'createUser',
		}),
		async handleSubmit() {
			this.$v.$touch();

			const isValidForm = !this.$v.$invalid;

			if (isValidForm) {
				await this.createUser({
					first_name: this.form.firstName,
					last_name: this.form.lastName,
					email: this.form.email,
					password: this.form.password,
					phone_number: this.form.phoneNumber,
					role: this.form.role?.value,
					is_active: this.form.status,
				});

				if (this.error === null) {
					// show toast with success
					this.showToast({
						header: this.$t('toast.success'),
						content: this.$t('toast.created_user'),
						type: 'success',
					});
					// redirect to user list pages
					this.$router.push({ name: ROUTER_NAME.USER_LIST });
				} else {
					// show toast with error
					this.showToast({
						header: this.$t('toast.unable_to_save'),
						content: this.error.message,
						type: 'danger',
					});
				}
			}
		},
		handleCancel() {
			// redirect to user list pages
			this.$router.push({ name: ROUTER_NAME.USER_LIST });
		},
	},
};
</script>